export { default } from './detailing';
